import axios from "axios";
import { AUTH_URL } from "../model/constants";
import { AuthResponseInterface } from "../model/auth.types";

const $auth_api = axios.create({
  withCredentials: true,
  baseURL: AUTH_URL
})

$auth_api.interceptors.request.use((config) => {
  if (!config.headers) config.headers = {};
  config.headers.Authorization = `Bearer ${localStorage.getItem('token')}`;
  return config;
});

$auth_api.interceptors.response.use(
  (config) => config,
  async (error) => {
    const originalRequest = error.config;
    if (
      error.response?.status === 401 &&
      error.config &&
      !error.config._isRetry &&
      error.config.url !== "/user/refresh-token" &&
      error.config.url !== "/user/logout"
    ) {
      originalRequest._isRetry = true;
      try {
        const response = await axios.post<AuthResponseInterface>(
          `${AUTH_URL}/user/refresh-token`,
          { client_id: "okgportal" },
          { withCredentials: true }
        );
        localStorage.setItem("token", response.data.data.tokens.accessToken.token);
        return $auth_api.request(originalRequest);
      } catch (e) {
        // console.log("НЕ АВТОРИЗОВАН");
      }
    }
    throw error;
  }
);

export default $auth_api;